import script from "./UserFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFilters.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__